
export const sFechaPublicacion = '2026-09-20T21:20:45.8375779-06:00';
export const sVersion = 'vf1.1.609202120';
            